import { render, staticRenderFns } from "./ModalPassport.vue?vue&type=template&id=5e143c4c&scoped=true&"
import script from "./ModalPassport.vue?vue&type=script&lang=js&"
export * from "./ModalPassport.vue?vue&type=script&lang=js&"
import style0 from "./ModalPassport.vue?vue&type=style&index=0&id=5e143c4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e143c4c",
  null
  
)

export default component.exports